import { Mail } from "lucide-react";
import { useState } from "react";

const Waitlist = () => {
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!email) {
      alert("Please enter your email");
      return;
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      alert("Please enter a valid email");
      return;
    }

    setIsSubmitting(true);

    // Simulate submission
    setTimeout(() => {
      alert("You're on the list! We'll be in touch soon.");
      setEmail("");
      setIsSubmitting(false);
    }, 1000);
  };

  return (
    <section id="waitlist" style={styles.section}>
      <div style={styles.container}>
        <div style={styles.content}>
          <h2 style={styles.title}>Join the Waitlist</h2>

          <p style={styles.subtitle}>
            Be the first to experience financial clarity
          </p>

          <form onSubmit={handleSubmit} style={styles.form}>
            <div style={styles.inputWrapper}>
              <Mail style={styles.mailIcon} />
              <input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                style={styles.input}
                disabled={isSubmitting}
              />
            </div>
            <button
              type="submit"
              disabled={isSubmitting}
              style={{
                ...styles.button,
                opacity: isSubmitting ? 0.7 : 1,
                cursor: isSubmitting ? "not-allowed" : "pointer",
              }}
            >
              {isSubmitting ? "Joining..." : "Join Waitlist"}
            </button>
          </form>

          <p style={styles.disclaimer}>No spam. Just updates when we launch.</p>
        </div>
      </div>
    </section>
  );
};

const styles: Record<string, React.CSSProperties> = {
  section: {
    padding: "3rem 1rem",
    backgroundColor: "#fff",
  },
  container: {
    maxWidth: "1280px",
    margin: "0 auto",
    padding: "0 1rem",
  },
  content: {
    maxWidth: "36rem",
    margin: "0 auto",
    textAlign: "center",
  },
  title: {
    fontSize: "clamp(1.75rem, 5vw, 2.5rem)",
    fontWeight: "600",
    marginBottom: "1.5rem",
    color: "#000",
  },
  subtitle: {
    fontSize: "clamp(1rem, 2.5vw, 1.125rem)",
    color: "#6b7280",
    marginBottom: "2rem",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "0.75rem",
  },
  inputWrapper: {
    position: "relative",
    flex: 1,
  },
  mailIcon: {
    position: "absolute",
    left: "1rem",
    top: "50%",
    transform: "translateY(-50%)",
    height: "1.25rem",
    width: "1.25rem",
    color: "#6b7280",
  },
  input: {
    width: "100%",
    paddingLeft: "3rem",
    paddingRight: "1rem",
    height: "3.5rem",
    borderRadius: "0.75rem",
    border: "1px solid rgba(0,0,0,0.1)",
    backgroundColor: "#fff",
    fontSize: "clamp(0.875rem, 2vw, 1rem)",
    boxSizing: "border-box",
  },
  button: {
    padding: "1rem 2rem",
    fontSize: "clamp(0.875rem, 2vw, 1rem)",
    backgroundColor: "#6366f1",
    color: "#fff",
    border: "none",
    borderRadius: "0.75rem",
    fontWeight: "500",
    height: "3.5rem",
    boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
    transition: "all 0.3s",
  },
  disclaimer: {
    fontSize: "clamp(0.688rem, 1.5vw, 0.75rem)",
    color: "#6b7280",
    marginTop: "1rem",
  },
};

export default Waitlist;
